module.exports = __webpack_public_path__ + "static/title-bg2.244558ef.png";